var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-chip',{staticClass:"ag-grid-cell-chip",attrs:{"transparent":true,"color":_vm.chipColor(_vm.params.data.customerType)}},[_c('span',[_vm._v(_vm._s(_vm.string(_vm.params.data.customerType)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }